import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "expander mt-2"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import {computed, onMounted, onUpdated, ref} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OnlineMessageTextContent from "~/core-ui/vue/chat/content/OnlineMessageTextContent.vue";
import OnlineMessageFileContent from "~/core-ui/vue/chat/content/OnlineMessageFileContent.vue";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import OnlineMessageKnowledgeBaseArticleContent
    from "~/core-ui/vue/chat/content/OnlineMessageKnowledgeBaseArticleContent.vue";
import OnlineMessageStickerContent from "~/core-ui/vue/chat/content/OnlineMessageStickerContent.vue";
import CoreUiHtmlifySnippetEventInterface from "~/core-ui/vue/ui/CoreUiHtmlifySnippetEventInterface";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {__} from "~/ts/library/Translate";
import CoreUiChatHistoryMessageButton from "~/core-ui/vue/chat/CoreUiChatHistoryMessageButton.vue";
import CoreUiChatHistoryMessageTitle from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTitle.vue";


//Никаких зависимостей кабинета или приложения оператора!!! Универсальный компонент

const __default__ = {
    name: "CoreUiChatHistoryMessageContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    messageActions: {},
    htmlify: {},
    operatorApplicationPlatform: {},
    recursive: { type: Boolean },
    operator: {},
    showSenderAndIconBeforeText: { type: Boolean },
    showOperatorLogins: { type: Boolean },
    bbcode: { type: Boolean }
  },
  emits: ["height-change", "snippet"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let replyContent = ref<HTMLDivElement>();
let showReplyContentExpander = ref(false);
let replyExpanded = ref(false);

function onHeightChange() {
    emits("height-change");
    makeReplyExpander();
}

function onReplyToMessageClick(replyToMessage: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    if (replyToMessage.id) {
        if (props.messageActions?.scrollToMessage) {
            props.messageActions?.scrollToMessage(replyToMessage.id);
        }
    }
}

onUpdated(() => {
    makeReplyExpander();
});

onMounted(() => {
    makeReplyExpander();
});

function makeReplyExpander() {
    if (props.message.replyToMessage && !props.recursive && replyContent.value) {
        showReplyContentExpander.value = replyContent.value.scrollHeight > replyContent.value.clientHeight;
    }
}

let hasText = computed(() => {
    let message = props.message;
    return (typeof message.content.text === 'string' && message.content.text.length > 0) || props.showSenderAndIconBeforeText;
});

return (_ctx: any,_cache: any) => {
  const _component_core_ui_chat_history_message_content = _resolveComponent("core-ui-chat-history-message-content", true)!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.message.replyToMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
                'reply-to-message': true,
                'message-color': true,
                first: !__props.recursive,
                expanded: _unref(replyExpanded)
            })
        }, [
          (__props.message.replyToMessage.isSendByClient && __props.message.replyToMessage.senderOverride?.name)
            ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageTitle, {
                key: 0,
                message: __props.message.replyToMessage,
                "operators-dictionary": {},
                "show-receiver": false,
                "show-operator-logins": false
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "message-content-color content",
            ref_key: "replyContent",
            ref: replyContent
          }, [
            _withDirectives(_createVNode(_component_core_ui_chat_history_message_content, {
              message: __props.message.replyToMessage,
              htmlify: __props.htmlify,
              "operator-application-platform": __props.operatorApplicationPlatform,
              onHeightChange: onHeightChange,
              recursive: "",
              class: _normalizeClass({
                        'cursor-pointer': __props.messageActions && __props.messageActions.scrollToMessage
                    })
            }, null, 8, ["message", "htmlify", "operator-application-platform", "class"]), [
              [_directive_on_native, () => onReplyToMessageClick(__props.message.replyToMessage), "click"]
            ])
          ], 512),
          (!__props.recursive && (_unref(showReplyContentExpander) || _unref(replyExpanded)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CoreUiChatHistoryMessageButton, {
                  icon: _unref(replyExpanded) ? 'chevron-up' : 'chevron-down',
                  "is-client": __props.message.isSendByClient,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(replyExpanded) //@ts-ignore
 ? replyExpanded.value = !_unref(replyExpanded) : replyExpanded = !_unref(replyExpanded)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(replyExpanded) ? _unref(__)('Свернуть') : _unref(__)('Развернуть')), 1)
                  ]),
                  _: 1
                }, 8, ["icon", "is-client"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(hasText))
      ? (_openBlock(), _createBlock(OnlineMessageTextContent, {
          key: 1,
          message: __props.message,
          bbcode: __props.bbcode,
          htmlify: __props.htmlify,
          onHeightChange: onHeightChange,
          onSnippet: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('snippet', $event))),
          "operator-application-platform": __props.operatorApplicationPlatform,
          operator: __props.operator,
          "show-sender-and-icon-before-text": __props.showSenderAndIconBeforeText,
          "show-operator-logins": __props.showOperatorLogins
        }, null, 8, ["message", "bbcode", "htmlify", "operator-application-platform", "operator", "show-sender-and-icon-before-text", "show-operator-logins"]))
      : _createCommentVNode("", true),
    (__props.message.typing)
      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
          key: 2,
          icon: "pencil",
          class: "ml-1"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
                'additional-content-wrapper': true,
                'has-text': _unref(hasText)
            })
    }, [
      (__props.message.content.sticker)
        ? (_openBlock(), _createBlock(OnlineMessageStickerContent, {
            key: 0,
            sticker: __props.message.content.sticker,
            onHeightChange: onHeightChange
          }, null, 8, ["sticker"]))
        : _createCommentVNode("", true),
      (__props.message.content.attachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.content.attachments, (attachment, key) => {
              return (_openBlock(), _createBlock(OnlineMessageFileContent, {
                key: key,
                attachment: attachment,
                "message-id": __props.message.id,
                "message-actions": __props.messageActions,
                htmlify: __props.htmlify,
                onHeightChange: onHeightChange
              }, null, 8, ["attachment", "message-id", "message-actions", "htmlify"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.message.content.knowledgeBaseArticles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.content.knowledgeBaseArticles, (article, key) => {
              return (_openBlock(), _createBlock(OnlineMessageKnowledgeBaseArticleContent, {
                key: key,
                article: article
              }, null, 8, ["article"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})